export default __webpack_public_path__ + "QKD-demo-talk-ES-V2.pdf";